import $ from 'jquery';
import { smoothscroll } from '../utils/smoothscroll';
import { flipSign } from '../utils/functions';

const $banner = $('.banner');
const $bannerMore = $('.banner__show-more');

$(function () {
    $bannerMore.on('click', function () {
        smoothscroll($banner, flipSign($banner.outerHeight()));
    });
});
